import CvSkeletonText from './CvSkeletonText.vue';
export { CvSkeletonText };
export default CvSkeletonText;
